import { useContext, useMemo } from 'react'

import { useSelector } from 'react-redux'

import { isEncoder } from '../utils/roles'
import { SchoolContext } from '../Providers/SchoolProvider'
import { selectUser } from '../reducers/UserReducer'

const useModules = () => {
  const sc = useContext(SchoolContext)

  const user = useSelector(selectUser)

  const modules = useMemo(() => ({
    internshipsDraft: isEncoder(user) && user.school.premium && sc?.useDraftInternships
  }), [user, sc])

  return modules
}

export default useModules
